import {
  Alert,
  Button,
  Col,
  CopyableTextWithLabel,
  Row,
  Space,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { DrawerFooterContent } from "melco-shared-logic";

type CopyChangeMachineLicensesProps = {

  onCloseDrawer: any;
  changeMachineLicensesResponse: any;
  successMessage?: string;
  title: string;
};

const AlertWrapper = styled.div`
  margin-bottom: 25px;
`;

export const CopyChangeMachineLicenses: React.FC<CopyChangeMachineLicensesProps> = ({
  title,
  changeMachineLicensesResponse,
  onCloseDrawer,
  successMessage,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <Space direction="vertical" size="middle">
          <Title level={4}>{title}</Title>
          <AlertWrapper>
            <Alert type="info" closable={false} message={successMessage} />
          </AlertWrapper>
        </Space>
        <Row>
          <Col xs={24} md={6}>
            <Space direction="vertical" size="middle">
              <CopyableTextWithLabel
                label={t("machinelicenses.copylicense.transactionid")}
                text={changeMachineLicensesResponse?.transaction_id ?? ""}
                copiedTooltip={t("machinelicenses.copylicense.copiedtooltip")}
                copyTooltip={t("machinelicenses.copylicense.copytooltip")}
                onCopiedMessage={t("machinelicenses.copylicense.oncopiedmessage")}
                key={"machineLicenses-copy"}
              />
            </Space>
          </Col>
        </Row>
        <DrawerFooterContent>
          <Row justify="end">
            <Button
              style={{ minWidth: "80px" }}
              key="add-user-button"
              type="primary"
              onClick={() => {
                onCloseDrawer();
              }}
            >
              {t("machinelicenses.buttons.done")}
            </Button>
          </Row>
        </DrawerFooterContent>
      </div>
    </>
  );
};
